exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NewsGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  grid-gap: 0.5em;\n  grid-template-columns: 1fr 1fr; }\n\n@media only screen and (max-width: 767px) {\n  .NewsGrid {\n    grid-template-columns: 1fr; } }\n", ""]);

// exports
